export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14275.6ffe185e.jpg";